export default __webpack_public_path__ + "static/media/chat1.8155b794.png";